<div class="pnc-detail-trial-reject-motivation" [ngStyle]="trialWrapperStyle"
     data-cy="pnc-detail-trial-reject-motivation">
    <div class="pnc-detail-trial-reject-motivation-description">
        <div class="pnc-detail-body-output-field-label"
             data-cy="pnc-detail-body-output-field-label-rejection-motivation">Reason for rejection
        </div>
        <div class="pnc-detail-body-output-field-value pnc-detail-trial-box-border"
             data-cy="pnc-detail-body-output-field-value-rejection-motivation">{{$safeNavigationMigration(trialRejectionMotivation?.motivationToReject) | undefinedValue}}</div>
    </div>
    <div class="pnc-detail-trial-by">
        <div class="pnc-detail-body-output-field-label" data-cy="pnc-detail-body-output-field-label-rejection-by-email">Rejected by</div>
        <div class="pnc-detail-body-output-field-value pnc-detail-body-output-field-value-email"
             data-cy="pnc-detail-body-output-field-value-rejection-by-email">{{$safeNavigationMigration(trialRejectionMotivation?.rejectedBy) | prettyPrintUpdatedBy | undefinedValue}}</div>
    </div>
</div>
